import type { Environment } from '../app/common/interfaces/utilities/environment';

export const environment: Environment = {
  type: 'production',
  publicApiNamespace: 'auth',
  apiUrl: 'https://api.onyxtms.com/api/v1',
  mercureUrl: 'https://api.onyxtms.com/.well-known/mercure',
  frontendUrl: 'https://app.onyxtms.com',
  hereMapsApiKey: '-8GDzbLolb5XS6g2COpmBmXiliSvSrBoZHEfPLvuGV0',
} as const;
